<template>
  <imp-panel title="用户列表">
    <div slot="body">
      <el-form :inline="true" class="demo-form-inline" size="small">
        <el-form-item label>
          <el-input
            v-model.trim="userNo"
            clearable
            placeholder="用户编号"
          />
        </el-form-item>
        <el-form-item label>
          <el-select v-model="status" clearable placeholder="状态">
            <el-option
              v-for="item in statusList"
              :key="item.itemId"
              :label="item.itemName"
              :value="item.itemId"
            />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            icon="el-icon-search"
            @click="queryList()"
          >查询</el-button>
        </el-form-item>
        <el-form-item>
          <router-link :to="{ path: '/userAdd' }">
            <el-button
              type="primary"
              icon="el-icon-plus"
              size="small"
            >新增</el-button>
          </router-link>
        </el-form-item>
      </el-form>
      <el-table
        v-loading="loading"
        border
        :data="tableData.rows"
        max-height="400px"
        :cell-style="{padding:'3px'}"
        stripe
        style="width: 100%"
      >
        <el-table-column
          prop="userNo"
          label="用户编号"
          width="100px"
        />
        <el-table-column prop="userName" label="用户名称" :show-overflow-tooltip="true"/>
        <el-table-column prop="phone" label="手机号" width="120px" />
        <el-table-column prop="email" label="邮箱" :show-overflow-tooltip="true"/>
        <el-table-column label="状态" width="85px">
          <template slot-scope="scope">
            <el-tag
              v-if="scope.row.status === 20"
              type="success"
              size="mini"
              disable-transitions
            >{{ getItemName(scope.row.status) }}</el-tag>
            <el-tag
              v-else-if="scope.row.status === 50"
              type="danger"
              size="mini"
              disable-transitions
            >{{ getItemName(scope.row.status) }}</el-tag>
            <el-tag v-else type="info" size="mini" disable-transitions>{{
              getItemName(scope.row.status)
            }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="540">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="default"
              icon="el-icon-edit"
              :disabled="scope.row.userId === 1 ? true : false"
              @click="handleEdit(scope.$index, scope.row)"
            >编辑</el-button>
            <el-button
              size="mini"
              type="primary"
              icon="el-icon-setting"
              :disabled="scope.row.userId === 1 ? true : false"
              @click="handleRoleConfig(scope.$index, scope.row)"
            >配置角色</el-button>
            <el-button
              size="mini"
              type="primary"
              icon="el-icon-setting"
              :disabled="scope.row.userId === 1 ? true : false"
              @click="handleUserGroupConfig(scope.$index, scope.row)"
            >配置用户组</el-button>
            <el-button
              size="mini"
              type="primary"
              icon="el-icon-setting"
              :disabled="scope.row.userId === 1 ? true : false"
              @click="handleResetPwd(scope.$index, scope.row)"
            >重置密码</el-button>
            <el-button
              v-if="scope.row.status != 50"
              size="mini"
              type="danger"
              icon="el-icon-circle-close"
              :disabled="scope.row.userId === 1 ? true : false"
              @click="setUserStatus(scope.row, 50)"
            >停用</el-button>
            <el-button
              v-if="scope.row.status === 50"
              size="mini"
              type="warning"
              icon="el-icon-circle-check"
              :disabled="scope.row.userId === 1 ? true : false"
              @click="setUserStatus(scope.row, 20)"
            >启用</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="block" style="text-align: right;">
        <el-pagination
          :current-page="tableData.pagination.pageNum"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="tableData.pagination.pageSize"
          :page-count="5"
          background
          layout="sizes, prev, pager, next"
          :total="tableData.pagination.totalSize * tableData.pagination.pageSize"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
      <!--修改用户信息-->
      <el-dialog
        title="修改用户信息"
        :visible.sync="showUserInfoDialog"
        :close-on-click-modal="false"
        @close="colseEdit"
      >
        <el-form
          ref="userInfoForm"
          status-icon
          size="small"
          :model="userInfoForm"
          :rules="rules"
          label-width="100px"
        >
          <el-form-item label="用户编号" prop="userNo">
            <el-input v-model="userInfoForm.userNo" clearable />
          </el-form-item>
          <el-form-item label="用户姓名" prop="userName">
            <el-input v-model="userInfoForm.userName" clearable />
          </el-form-item>
          <el-form-item label="邮箱" prop="email">
            <el-input v-model="userInfoForm.email" clearable />
          </el-form-item>
          <el-form-item label="手机号" prop="phone">
            <el-input
              v-model="userInfoForm.phone"
              clearable
              maxlength="11"
            />
          </el-form-item>
          <el-form-item label="状态">
            <el-radio-group v-model="userInfoForm.status" @change="setUserStatus(userInfoForm,userInfoForm.status)">
              <el-radio :label="10">未激活</el-radio>
              <el-radio :label="20">已激活</el-radio>
            </el-radio-group>
          </el-form-item>
          <!-- <el-form-item label="起始时间" prop="time">
            <el-date-picker
              v-model="userInfoForm.time"
              type="daterange"
              align="right"
              unlink-panels
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
              :picker-options="pickerOptions">
            </el-date-picker>
            <span>(特定角色生效)</span>
          </el-form-item> -->
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button
            size="small"
            @click="showUserInfoDialog = false"
          >取 消</el-button>
          <el-button
            size="small"
            type="primary"
            @click="editUserInfo()"
          >确 定</el-button>
        </span>
      </el-dialog>
      <!--配置用户角色-->
      <el-dialog
        title="配置用户角色"
        :visible.sync="showRoleDialog"
        :close-on-click-modal="false"
        :close="colseRole"
      >
        <div class="select-tree">
          <el-scrollbar
            tag="div"
            class="is-empty"
            wrap-class="el-select-dropdown__wrap"
            view-class="el-select-dropdown__list"
          >
            <el-tree
              ref="roles"
              :data="roleTree"
              show-checkbox
              check-on-click-node
              node-key="id"
              @check="handleCheckChange"
            />
          </el-scrollbar>
        </div>
        <el-form
          ref="userConfigForm"
          status-icon
          size="small"
          :model="userConfigForm"
          label-width="100px"
          v-if="showUserConfig"
        >
          <el-form-item label="日期限制" prop="time">
            <el-date-picker
              v-model="userConfigForm.time"
              type="daterange"
              align="right"
              unlink-panels
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
              :picker-options="pickerOptions">
            </el-date-picker>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button
            size="small"
            type="primary"
            @click="setRole()"
          >确 定</el-button>
        </span>
      </el-dialog>
      <!--配置用户组-->
      <el-dialog
        title="配置用户组"
        :visible.sync="showUserGroupDialog"
        :close-on-click-modal="false"
        :close="colseGroup"
      >
        <div class="select-tree">
          <el-scrollbar
            tag="div"
            class="is-empty"
            wrap-class="el-select-dropdown__wrap"
            view-class="el-select-dropdown__list"
          >
            <el-tree
              ref="groups"
              :data="groupTree"
              show-checkbox
              check-on-click-node
              node-key="id"
              @check="handleGroup"
            />
          </el-scrollbar>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button
            size="small"
            type="primary"
            @click="setGroup()"
          >确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </imp-panel>
</template>
<script>
import {
  getUserListApi,
  getInfo,
  setUserStatusApi,
  addUserRoleApi,
  deleteUserRoleApi,
  editUserApi,
  resetPwdByAdminApi,
  getRoleListApi,
} from '../../service/user.js';
import {
  getDictDataListApi, 
  getGroupsApi, 
  getUserGroupsApi,
  addUserGroupApi,
  deleteUserGroupApi,
  getUserConfigApi,
  updateUserConfigApi,
} from '../../service/api.js';
import panel from "../layout/panel.vue";
export default {
  name: 'UserList',
  components: {
    "imp-panel": panel
  },
  data() {
    return {
      showUserConfig:false,
      userConfigForm:{
        time: [],
      },
      showUserGroupDialog: false,
      groupTree: [],
      firstOpen: false,
      userNo: '',
      status: '',
      statusList: [],
      showUserInfoDialog: false,
      showRoleDialog: false,
      formLabelWidth: '120px',
      selectUserId: '',
      userId: window.localStorage.getItem('userId'),
      roleTree: [],
      permission: true,
      tableData: {
        pagination: {
          total: 0,
          pageNum: 1,
          pageSize: 10,
          totalSize: 0
        },
        rows: []
      },
      loading: false,
      userInfoForm: {
        userId: '',
        userName: '',
        userNo: '',
        email: '',
        phone: '',
        status: '',
        // time: [],
      },
      rules: {
        userNo: [{ required: true, message: '请输入用户编号', trigger: 'blur' }],
        userName: [
          { required: true, message: '请输入用户名称', trigger: 'blur' }
        ],
        email: [
          { required: true, message: '请输入邮箱地址', trigger: 'blur' },
          { type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur'] }
        ],
        phone: [
          { min: 11, max: 11, message: '长度为11个字符', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 6, message: '长度大于6个字符', trigger: 'blur' }
        ]
      },
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一年',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三年',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 1095);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
    }
  },
  computed: {
    isRole() {
      if (window.localStorage.getItem('roles').indexOf(10) > -1) {
        return true
      } else {
        return false
      }
    }
  },
  created() {
    this.getDictDataList(9)
    this.getUserGroups()
    this.getRoleList()
  },
  mounted() {
    this.getUserList()
  },
  methods: {
    test(){
      docExcelExportApi({
        userId:"2",
      });
    },
    // 获取角色列表
    getRoleList(){
      console.log("get roles")
      this.roleTree = []
      getRoleListApi({}).then(res => {
        if (res && res.code == 200) {
          for (var i = 0; i < res.items.length; i++) {
            this.roleTree.push({
              id: res.items[i].id, 
              label: res.items[i].roleDesc,
            })
          }
        }else{
          this.$message.error("error code:"+res.code);
        }
      }).catch(err =>{})
    },
    // 获取数据字典列表(状态：全部)
    getDictDataList(groupId){
      getDictDataListApi({
        userId:window.localStorage.getItem('userId'),          
        groupId: groupId,
        status: 1
      }).then(res=>{
        if(res && res.code == 0){
          if(res.items && res.items.length>0){
            this.statusList = res.items
          }
        } else {
          this.$message.error("error code:"+res.code+";"+res.message);
        }
      })
    },
    getItemName(itemId) {
      for (let i = 0; i < this.statusList.length; i++) {
        if (this.statusList[i].itemId === itemId) {
          return this.statusList[i].itemName
        }
      }
    },

    handleSizeChange(val) {
      this.tableData.pagination.pageSize = val
      this.getUserList()
    },
    handleCurrentChange(val) {
      this.tableData.pagination.pageNum = val
      this.getUserList()
    },
    queryList() {
      this.tableData.pagination.pageNum = 1
      this.getUserList()
    },
    // 获取用户列表
    getUserList() {
      getUserListApi({
        pageNo: this.tableData.pagination.pageNum,
        pageSize: this.tableData.pagination.pageSize,
        userNo: this.userNo,
        status: this.status
      }).then((res) => {
        if (res && res.code === 200) {
          this.tableData.pagination.totalSize = res.totalPage
          this.tableData.rows = res.items
        } else {
          this.$message.error("error code:"+res.code+";"+res.message);
        }
      })
    },

    // 打开修改页面
    handleEdit(index, row) {
      // this.userInfoForm.time=[]
      // this.getUserConfig(row.userId)
      this.getUserInfo(row)
    },
    // 关闭修改页面
    colseEdit() {
      this.$refs['userInfoForm'].resetFields()
    },
    // 修改用户
    editUserInfo() {
      this.$refs['userInfoForm'].validate((valid) => {
        if (valid) {
          editUserApi({
            userId: this.userInfoForm.userId,
            userName: this.userInfoForm.userName,
            userNo: this.userInfoForm.userNo,
            email: this.userInfoForm.email,
            phone: this.userInfoForm.phone
          }).then((res) => {
            if (res && res.code === 200) {
              this.$message.success('修改成功')
            } else {
              this.$message.error("error code:"+res.code+";"+res.message);
            }
          })
          
        }
      })
    },
    updateUserConfig() {
      updateUserConfigApi({
        userId: this.selectUserId,
        startTime: this.userConfigForm.time[0],
        endTime: this.userConfigForm.time[1]
      }).then((res) => {
        if (res && res.code == 0) {
          this.$message.success('修改成功')
          this.showUserConfig = false
          this.userConfigForm.time = []
          this.$refs.roles.setCheckedKeys([])
          this.selectUserId = ''
          this.showRoleDialog = false
        } else {
          this.$message.error("error code:"+res.code+";"+res.message);
        }
      })
    },

    // 打开当前用户权限
    handleRoleConfig(index, row) {
      this.showRoleDialog = true
      this.selectUserId = row.userId
      this.showUserConfig = false
      this.userConfigForm.time = []
      getInfo({
        userId: row.userId
      }).then((res) => {
        if (res && res.code === 200) {
          if (res.roles && res.roles.length > 0) {
            this.$refs.roles.setCheckedKeys(res.roles)
            if (res.roles.indexOf(4) > -1 || res.roles.indexOf(5) > -1) {
              this.showUserConfig = true;
              this.getUserConfig()
            }
          } else {
            this.$refs.roles.setCheckedKeys([])
          }
        } else {
          this.$message.error("error code:"+res.code+";"+res.message);
        }
      })
    },
    // 关闭权限页面
    colseRole() {
      this.$refs.roles.setCheckedKeys([])
      this.selectUserId = ''
      this.userConfigForm.time = []
    },

    // 配置用户权限
    handleCheckChange(data, node) {
      console.log(data, node)
      var flag = false
      for (let i = 0; i < node.checkedKeys.length; i++) {
        // 选中特定角色时，时间配置
        if (node.checkedKeys[i] == 4 || node.checkedKeys[i] == 5 && !this.showUserConfig) {
          this.showUserConfig = true
          this.getUserConfig()
        }
        if (node.checkedKeys[i] == 4 || node.checkedKeys[i] == 5) {
          flag = true
        }
      }
      if (!flag) {
        // 隐藏时间配置
        this.showUserConfig = false
      }
      for (var i = 0; i < node.checkedKeys.length; i++) {
        if (data.id === node.checkedKeys[i]) {
          this.addUserRole(data)
          return
        }
      }
      this.deleteUserRole(data)
      
    },
    // 添加用户权限
    addUserRole(data) {
      addUserRoleApi({
        uid: this.selectUserId,
        rid: data.id
      }).then(res => {
        if (res && res.code === 200) {
          this.$message.success("添加权限成功：" + data.label)
        } else {
          this.$message.error("操作失败")
        }
      }).catch(err => {
        console.error(err)
      })
    },
    // 删除用户权限
    deleteUserRole(data) {
      if (!(this.selectUserId && data.id)) return
      deleteUserRoleApi({
        userId: this.selectUserId,
        roleId: data.id
      }).then(res => {
        if (res && res.code === 200) {
          this.$message.success("取消权限成功：" + data.label)
        } else {
          this.$message.error("操作失败")
        }
      }).catch(err => {
        console.error(err)
      })
    },
    setRole() {
      if (this.userConfigForm.time && this.showUserConfig) {
        this.updateUserConfig()
        return
      }
      this.userConfigForm.time = []
      this.$refs.roles.setCheckedKeys([])
      this.selectUserId = ''
      this.showRoleDialog = false
    },

    // 获取用户信息
    getUserInfo(row) {
      getInfo({
        userId: row.userId
      }).then((res) => {
        if (res && res.code === 200) {
          this.showUserInfoDialog = true
          this.userInfoForm.userId = res.userId
          this.userInfoForm.userName = res.userName
          this.userInfoForm.userNo = res.userNo
          this.userInfoForm.email = res.email
          this.userInfoForm.phone = res.phone
          this.userInfoForm.status = res.status
        } else {
          this.$message.error("error code:"+res.code+";"+res.message);
        }
      })
    },

    // 修改用户状态
    setUserStatus(row, status) {
      console.log(row.userId, status)
      setUserStatusApi({
        userId: String(row.userId),
        status: status
      }).then((res) => {
        if (res && res.code === 200) {
          this.$message.success('修改成功')
          this.getUserList()
        } else {
          this.$message.error("error code:"+res.code+";"+res.message);
        }
      })
    },

    // 获取用户组列表
    getUserGroups(){
      getGroupsApi({
        sessionId: window.localStorage.getItem("sessionId"),
        userId: window.localStorage.getItem("userId"),
      }).then(res =>{
        if (res && res.items && res.code == 0) {
          var groups = []
          this.groupTree = []
          for (var i=0; i<res.items.length; i++) {
            res.items[i].label = res.items[i].groupName
            groups.push(res.items[i])
          }
          this.groupTree = groups
        } else {
          this.$message.error("error code:"+res.code+";"+res.message);
        }
      })
    },
    // 点击修改用户组、初始化已选
    handleUserGroupConfig(index, row){
      this.showUserGroupDialog = true
      this.selectUserId = row.userId
      getUserGroupsApi({
        userId: String(this.selectUserId)
      }).then((res) => {
        if (res && res.code == 0) {
          if (res.items && res.items.length > 0) {
            for (var i=0; i<res.items.length; i++) {
              res.items[i].id = res.items[i].userGroupId
            }
            console.log(res.items)
            this.$refs.groups.setCheckedNodes(res.items)
          } else {
            this.$refs.groups.setCheckedNodes([])
          }
        } else {
          this.$message.error("error code:"+res.code+";"+res.message);
        }
      })
    },
    // 选中/取消 用户组操作
    handleGroup(data, node){
      console.log(data, node)
      for (var i = 0; i < node.checkedKeys.length; i++) {
        if (data.id === node.checkedKeys[i]) {
          this.addUserGroup(data)
          return
        }
      }
      this.deleteUserGroup(data)
    },
    //配置用户组
    addUserGroup(data){
      if (!(this.selectUserId && data.id)) return
      addUserGroupApi({
        sessionId: window.localStorage.getItem("sessionId"),
        operatorId: window.localStorage.getItem("userId"),
        userId: String(this.selectUserId),
        groupId: data.id
      }).then(res => {
        if (res && res.code == 0) {
          this.$message.success("添加用户组成功：" + data.label)
        } else {
          this.$message.error("操作失败")
        }
      }).catch(err => {
        console.error(err)
      })
    },
    // 反配置用户组
    deleteUserGroup(data){
      if (!(this.selectUserId && data.id)) return
      deleteUserGroupApi({
        sessionId: window.localStorage.getItem("sessionId"),
        operatorId: window.localStorage.getItem("userId"),
        userId: String(this.selectUserId),
        groupId: data.id
      }).then(res => {
        if (res && res.code == 0) {
          this.$message.success("删除用户组：" + data.label)
        } else {
          this.$message.error("操作失败")
        }
      }).catch(err => {
        console.error(err)
      })
    },
    // 关闭用户组配置弹窗
    setGroup() {
      this.$refs.groups.setCheckedKeys([])
      this.selectUserId = ''
      this.showUserGroupDialog = false
    },
    // 关闭用户组配置弹窗
    colseGroup() {
      this.$refs.groups.setCheckedNodes([])
      this.selectUserId = ''
    },
    // 管理员重置密码
    handleResetPwd(index,row) {
      var userName = row.userName
      this.$msgbox({
          title: '重置密码提示',
          message: '此操作将重置用户 ' + userName + ' 的登录密码, 是否继续?',
          showCancelButton: true,
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          showClose: false,
          beforeClose: (action, instance, done) => {
            if (action === 'confirm') {
              instance.confirmButtonLoading = true;
              instance.showCancelButton = false;
              instance.confirmButtonText = '重置中...';
              setTimeout(() => {
                this.resetPwd(row)
                done();
                setTimeout(() => {
                  instance.confirmButtonLoading = false;
                }, 300);
              }, 3000);
            } else {
              done();
            }
          },
        }).then(action => {
          this.$message({
            type: 'success',
            message: '操作成功'
          })
        }).catch(action =>{});
    },
    resetPwd(row) {
      resetPwdByAdminApi({
        uid: row.userId
      }).then(res =>{
        if (res && res.code == 200) {
          this.$alert(res.password, '新密码(请复制保存)', {
            confirmButtonText: '确定',
            center: true,
          });
        } else (
          this.$message("error code: "+res.code+","+"message: "+res.message)
        )
      }).catch(err =>{})
    },
    getUserConfig() {
      getUserConfigApi({
        id: this.selectUserId
      }).then(res => {
        if (res && res.code == 0) {
          var times = [res.userConf.startTime, res.userConf.endTime]
          this.$set(this.userConfigForm, "time", times)
        }
      })
    }
  }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/user/userList.vue